import { defineStore } from 'pinia'

// Main application store
export const useAppStore = defineStore('app', {
    state: () => ({
        // Auth
        isLoggedin: false,
        user: null,
        baseUrl: null,
        entity: 'tramontane',

        // Data lists
        allChildsList: [],
        allUsersList: [],
        allFilesList: [],
        allForumPostsList: [],

        // Generic pagination state
        paginationState: {},

        // UI state
        dataSave: '',
        calendarVisibility: {
            observations: true,
            gardes: true,
            files: true
        },
        ignoreWarning: false,

        // Forum notifications
        isForumNewPosts: false,
        activeForumNewPostsList: [],
        isForumNewPostComments: false,
        activeForumNewPostCommentsList: [],

        // Static options
        userPermissionsOptions: [
            { value: 'admin', label: 'Admin' },
            { value: 'child', label: 'Gestion des enfants' },
            { value: 'staff', label: 'Gestion du personnel' },
            { value: 'shared', label: 'Gestion des documents partagés' },
            { value: 'personaldata', label: 'Gestion des documents du personnel' },
            { value: 'garde', label: 'Gestion des gardes' },
            { value: 'forum', label: 'Accès au forum' },
            { value: 'pv', label: 'Gestion des PV' },
            { value: 'valves', label: 'Gestion des valves' },
            { value: 'stagiaire', label: 'Stagiaire' },
            { value: 'staffgarde', label: 'Personnel de garde' },
            { value: 'medicale', label: 'Gestion Médicale' },
            { value: 'overtime', label: 'Gestion heures supplémentaires' },
            { value: 'sorti', label: 'Personnel de sorti' }
        ],
        childGroupesOptions: [
            { value: 'pe', label: 'Petits' },
            { value: 'mo', label: 'Moyens' },
            { value: 'ad', label: 'Ados' },
            { value: 'sf', label: 'Suivis familles' },
            { value: 'sa', label: 'Suivis apparts' },
            { value: 'au', label: "Accueils d'urgence" },
            { value: 'be', label: 'Bénéficiaires sortis' },
            { value: 'ca', label: "En cours d'admission" }
        ],
        filesCategoryOptions: [
            { value: 'ni', label: 'Notes internes' },
            { value: 'ts', label: 'Courriers divers' },
            { value: 'ps', label: 'Rapports' },
            { value: 'fi', label: 'Pièces officielles' },
            { value: 'sc', label: 'Scolaires' },
            { value: 'me', label: 'Medicale' }
        ],
        weekOptions: [
            { value: 'lundi', label: 'Lundi' },
            { value: 'mardi', label: 'Mardi' },
            { value: 'mercredi', label: 'Mercredi' },
            { value: 'jeudi', label: 'Jeudi' },
            { value: 'vendredi', label: 'Vendredi' },
            { value: 'samedi', label: 'Samedi' },
            { value: 'dimanche', label: 'Dimanche' }
        ],
        fileUsersWatchedAcces: [
            'bruno@weblartiste.be',
            'serge.lahaye@latramontane.be',
            'julie.baeselen@latramontane.be',
            'karen.marchadour@latramontane.be',
            'jeremy.collet@latramontane.be',
            'joseph1982@gmail.com'
        ]
    }),

    actions: {
        // Auth actions
        setUser(data) {
            this.user = data
        },
        setLoggedIn(data) {
            this.isLoggedin = data
        },
        setBaseUrl(data) {
            this.baseUrl = data
        },
        setEntity(data) {
            this.entity = data
        },

        // Data list actions
        setUsers(data) {
            this.allUsersList = data
        },
        setChilds(data) {
            this.allChildsList = data
        },
        setFiles(data) {
            this.allFilesList = data
        },

        // Generic pagination actions
        setPaginationState(key, data) {
            this.paginationState[key] = data
        },
        getPaginationState(key) {
            return this.paginationState[key] || null
        },

        // UI actions
        setData(data) {
            this.dataSave = data
        },
        toggleCalendarVisibility(key) {
            this.calendarVisibility[key] = !this.calendarVisibility[key]
        },
        toggleIgnoreWarning(data) {
            this.ignoreWarning = data
        },

        // Forum actions
        setAllForumPostsList(data) {
            this.allForumPostsList = data
        },
        setIsForumNewPosts(data) {
            this.isForumNewPosts = data
        },
        setActiveForumNewPostsList(data) {
            this.activeForumNewPostsList = data
        },
        setIsForumNewPostComments(data) {
            this.isForumNewPostComments = data
        },
        setActiveForumNewPostCommentsList(data) {
            this.activeForumNewPostCommentsList = data
        }
    }
})
